import { ICONS, Icon } from '@captaincause/ui/Icon'
import { tm } from '@captaincause/ui/tm'
import CallToAction from './CallToAction'
import type { IconKeys } from '@captaincause/ui/Icon'
import type { ButtonProps } from 'components/Button'
import type { StrapiLink } from 'types/strapi/link'

type FlowItem = {
  id: number
  iconName: string
  title: string
  description: string
}
export type FlowProps = {
  title: string
  flowItems: FlowItem[]
  bannerTitle: string
  bannerCTA?: (StrapiLink & { locale?: ButtonProps['locale'] }) | null
}

const iconList = Object.keys(ICONS)

export default function Flow({
  title,
  flowItems,
  bannerTitle,
  bannerCTA = null,
}: FlowProps) {
  if (flowItems.length === 0) return null

  return (
    <div className="m-auto flex w-full max-w-[1400px] flex-col items-center gap-14 bg-white px-4 py-10 md:px-20 md:py-20">
      <h2 className="text-center font-default text-3xl font-semibold leading-8 -tracking-[1.5px] md:text-[40px] md:leading-[48px]">
        {title}
      </h2>
      <div
        className={tm(
          'grid w-full grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4',
          flowItems.length === 1 && 'lg:grid-cols-1',
          flowItems.length === 2 && 'lg:grid-cols-2',
          flowItems.length === 3 && 'lg:grid-cols-3',
          flowItems.length === 4 && 'lg:grid-cols-4',
          flowItems.length === 5 && 'lg:grid-cols-5',
          flowItems.length === 6 && 'lg:grid-cols-6',
          flowItems.length === 7 && 'lg:grid-cols-7',
        )}
      >
        {flowItems.map(item => {
          const icon = !iconList.includes(item.iconName)
            ? 'check'
            : (item.iconName as IconKeys)

          return (
            <div className="flex w-full flex-1 flex-col gap-6" key={item.id}>
              <div className="flex items-center">
                <div className="rounded-2xl bg-medium-purple p-2">
                  <Icon icon={icon} fill="fill-dark-purple" />
                </div>

                <hr
                  className="ml-2 h-[4px] w-full border-none bg-medium-gray bg-[linear-gradient(to_right,_transparent_50%,_white_50%)]"
                  style={{
                    backgroundSize: '30px 1px',
                    backgroundPositionX: '-10px',
                  }}
                />
              </div>
              <div className="h-full rounded-2xl bg-light-gray p-6">
                <h3 className="mb-2 break-words font-default text-lg font-semibold leading-8">
                  {item.title}
                </h3>
                <p className="line-clamp-3 break-words leading-7 text-dark-gray">
                  {item.description}
                </p>
              </div>
            </div>
          )
        })}
      </div>
      {bannerTitle && bannerCTA ? (
        <CallToAction
          title={bannerTitle}
          link={{ url: bannerCTA.url, title: bannerCTA.title }}
          ficellos="green-orange"
          contained
          withoutContainerPadding
          locale={bannerCTA.locale}
        />
      ) : null}
    </div>
  )
}
